import { AbsoluteFill, useCurrentFrame, useVideoConfig, interpolate } from "remotion";
import React from "react";

// VFX: Bokeh Heart Particles
// Category: overlays · Tags: bokeh, hearts, romantic, particles, lifestyle
export default function FxBokehHeartsFloat2000Ms() {
  const frame = useCurrentFrame();
  const { width, height, durationInFrames } = useVideoConfig();
  const hearts = Array.from({ length: 24 }, (_, i) => {
    const seed = i * 137.5;
    const x = (Math.sin(seed) * 0.5 + 0.5) * width;
    const startY = height + 80 + (i % 5) * 30;
    const speed = 0.4 + ((i * 7) % 10) / 20;
    const y = startY - (frame / durationInFrames) * height * 1.3 * speed - i * 8;
    const drift = Math.sin(frame * 0.05 + i) * 30;
    const size = 30 + (i % 4) * 20;
    const blur = (i % 3) * 4;
    const opacity = interpolate(y, [-100, height * 0.7, height + 80], [0, 0.85, 0], { extrapolateLeft: "clamp", extrapolateRight: "clamp" });
    const hue = 340 + (i % 5) * 6;
    return { x: x + drift, y, size, blur, opacity, hue };
  });
  return (
    <AbsoluteFill style={{ background: "transparent" }}>
      {hearts.map((h, i) => (
        <div key={i} style={{
          position: "absolute", left: h.x, top: h.y,
          width: h.size, height: h.size,
          opacity: h.opacity, filter: `blur(${h.blur}px)`,
          fontSize: h.size, color: `hsl(${h.hue}, 80%, 70%)`,
          textShadow: `0 0 16px hsla(${h.hue},80%,70%,0.8)`,
        }}>❤</div>
      ))}
    </AbsoluteFill>
  );
}

;
    var _remotion_globalVariableA;
    var _remotion_globalVariableB;
    // Legacy CSS implementations will `eval` browser code in a Node.js context
    // to extract CSS. For backwards compatibility, we need to check we're in a
    // browser context before continuing.
    if (typeof self !== 'undefined' &&
        // AMP / No-JS mode does not inject these helpers:
        '$RefreshHelpers$' in self) {
        const currentExports = __webpack_module__.exports;
        const prevExports = (_remotion_globalVariableB = (_remotion_globalVariableA = __webpack_module__.hot.data) === null || _remotion_globalVariableA === void 0 ? void 0 : _remotion_globalVariableA.prevExports) !== null && _remotion_globalVariableB !== void 0 ? _remotion_globalVariableB : null;
        // This cannot happen in MainTemplate because the exports mismatch between
        // templating and execution.
        self.$RefreshHelpers$.registerExportsForReactRefresh(currentExports, __webpack_module__.id);
        // A module can be accepted automatically based on its exports, e.g. when
        // it is a Refresh Boundary.
        if (self.$RefreshHelpers$.isReactRefreshBoundary(currentExports)) {
            // Save the previous exports on update so we can compare the boundary
            // signatures.
            __webpack_module__.hot.dispose((data) => {
                data.prevExports = currentExports;
            });
            // Unconditionally accept an update to this module, we'll check if it's
            // still a Refresh Boundary later.
            __webpack_module__.hot.accept();
            // This field is set when the previous version of this module was a
            // Refresh Boundary, letting us know we need to check for invalidation or
            // enqueue an update.
            if (prevExports !== null) {
                // A boundary can become ineligible if its exports are incompatible
                // with the previous exports.
                //
                // For example, if you add/remove/change exports, we'll want to
                // re-execute the importing modules, and force those components to
                // re-render. Similarly, if you convert a class component to a
                // function, we want to invalidate the boundary.
                if (self.$RefreshHelpers$.shouldInvalidateReactRefreshBoundary(prevExports, currentExports)) {
                    __webpack_module__.hot.invalidate();
                }
                else {
                    self.$RefreshHelpers$.scheduleUpdate();
                }
            }
        }
        else {
            // Since we just executed the code for the module, it's possible that the
            // new exports made it ineligible for being a boundary.
            // We only care about the case when we were _previously_ a boundary,
            // because we already accepted this update (accidental side effect).
            const isNoLongerABoundary = prevExports !== null;
            if (isNoLongerABoundary) {
                __webpack_module__.hot.invalidate();
            }
        }
    }
